import styled from 'styled-components'
import theme from '../../theme/theme';

export const MainWrapper = styled.div`
margin: 0 10%;
`;

export const TopContainer = styled.div`
display: flex;
flex-direction: column;
justify-content: center;
align-items: start;
`;

export const MainHeader = styled.h1`
font-size: 3rem;
font-weight: 700;
color: ${theme.color.navy};
margin: 10 auto 5px;

@media (max-width: 640px) {
    font-size: 2.5rem;
}
`;

export const ButtonContainer = styled.div`
display: flex;
align-items: center;
justify-content: center;
width: 100%;
margin: 30px auto;
gap: 10px;
@media (max-width: 1024px) {
    flex-direction: column;
}
`;

export const Button = styled.button<{ color: string }>`
background-color: ${(props) => props.color === "red" ? theme.color.ruby : theme.color.navy};
color: ${theme.color.white};
border: none;
border-radius: 8px;
padding: 10px;
font-size: 1rem;
width: 100%;
`;

export const Header2 = styled.h2`
font-size: 2rem;
font-weight: 700;
color: ${theme.color.navy};
margin: 30px auto 5px;

@media (max-width: 640px) {
    font-size: 1.5rem;
}
`;

export const Info = styled.p`
font-size: 1.2rem;
`;

export const Bullet = styled.li`
font-size: 1.2rem;
`;